import React, { useCallback, useEffect, useState } from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'
import ApiClient from 'api-client/ApiClient'

interface Props {
  name?: string
  label?: string
}

export default function ServicePicklist({
  name = 'service',
  label = 'Service',
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  const [loading, setLoading] = useState(true)
  const [services, setServices] = useState<string[]>([])

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const catalog = await ApiClient.getInstance().keystone.getServiceCatalog()
        const serviceNames = catalog.map((service) => service.type)
        const uniqueServices = [...new Set(serviceNames)] as string[]
        setServices(uniqueServices)
      } catch (error) {
        console.error('Failed to fetch service catalog:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchServices()
  }, [])

  const toDropdownOptions = useCallback(() => {
    return services.map((service) => ({
      label: service,
      value: service,
    }))
  }, [services])

  return (
    <AsyncDropdown
      name={name}
      label={label}
      items={toDropdownOptions()}
      loading={loading}
      {...rest}
    />
  )
}
